<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>Contents</span></p>
<p class="toc-entrya"><span><a href="#/xhtml/endmatter02">Publisher’s Note</a></span></p>
<p class="toc-entry"><span><a href="#/xhtml/part01">ONE</a></span></p>
<p class="toc-entry1"><span><a href="#/xhtml/chapter001"><i>Piecing</i></a></span></p>
<p class="toc-entry1"><span><a href="#/xhtml/chapter002"><i>Heirloom</i></a></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample"><i>Death Benefits</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample"><i>Nature’s Garden</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample"><i>Peony</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part02" title="Link target outside of Sample">TWO</span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample"><i>Three Definitions of Poetry</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample"><i>Battery</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample"><i>Two by Two</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample"><i>Phobophilia</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample"><i>The Ruining of the Work</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part03" title="Link target outside of Sample">THREE</span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample"><i>The Duel: A Masque</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part04" title="Link target outside of Sample">FOUR</span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample"><i>Documentary</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample"><i>Aerial View</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample"><i>Elegy</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter015" title="Link target outside of Sample"><i>White Sound</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter016" title="Link target outside of Sample"><i>The Fall of a Sparrow</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part05" title="Link target outside of Sample">FIVE</span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter017" title="Link target outside of Sample"><i>The Harrowing of Heaven</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter018" title="Link target outside of Sample"><i>Three Salt Sonnets to an Incidental Lover</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter019" title="Link target outside of Sample"><i>The Undead: A Pentode of Seasons</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter020" title="Link target outside of Sample"><i>Depth Perception</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/chapter021" title="Link target outside of Sample"><i>The Hallowing of Hell</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter022" title="Link target outside of Sample">Acknowledgments</span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?433ec911